import { useXSellAnalytic } from 'client/common/analytic/useXSellAnalytic'
import {
  LAST_VIEWED_LISTER_LIST_TYPE,
  LAST_VIEWED_SEARCH_LIST_TYPE,
  LAST_VIEWED_ZERO_SEARCH_LIST_TYPE,
  LISTER_IMPRESSIONS_PRODUCT,
  SEARCH_IMPRESSIONS_PRODUCT
} from 'client/common/analytic/analytic'
import { subscribeAndProcess } from 'client/common/pageBus'
import { useEffect, useState } from 'react'

export const useLastViewedAnalytic = data => {
  const [type, setType] = useState(LAST_VIEWED_ZERO_SEARCH_LIST_TYPE)

  useEffect(() => {
    subscribeAndProcess('last-viewed-listener', LISTER_IMPRESSIONS_PRODUCT, () => {
      setType(LAST_VIEWED_LISTER_LIST_TYPE)
    })
    subscribeAndProcess('last-viewed-listener', SEARCH_IMPRESSIONS_PRODUCT, () => {
      setType(LAST_VIEWED_SEARCH_LIST_TYPE)
    })
  }, [])

  return useXSellAnalytic(data, type)
}
